import { Alert } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Navigate } from 'react-router-dom';

export type PageAccessConfig = {
  useAccess: () => boolean;
  redirectTo?: string;
};

function renderDenied(redirectTo?: string): React.ReactElement {
  return redirectTo ? (
    <Navigate to={redirectTo} replace />
  ) : (
    <Alert color="red" variant="light">
      Доступ запрещен
    </Alert>
  );
}

export const withPageAccess = <P extends Record<string, unknown>>(
  Component: React.ComponentType<P>,
  { useAccess, redirectTo }: PageAccessConfig,
) =>
  observer((props: P) => {
    const hasAccess = useAccess();

    if (!hasAccess) {
      return renderDenied(redirectTo);
    }

    return <Component {...props} />;
  });
